var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperienceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.129 5.07512L21.4627 8.39621L21.6381 8.83315L22.1079 8.865L25.6786 9.10711L22.9322 11.4018L22.5708 11.7037L22.6857 12.1603L23.5588 15.631L20.5278 13.7281L20.129 13.4777L19.7302 13.7281L16.6992 15.631L17.5723 12.1603L17.6872 11.7037L17.3259 11.4018L14.5795 9.10711L18.1501 8.865L18.6199 8.83315L18.7954 8.39621L20.129 5.07512Z",
    stroke: "#C93030",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87902 5.07512L9.21268 8.39621L9.38814 8.83315L9.85792 8.865L13.4286 9.10711L10.6822 11.4018L10.3208 11.7037L10.4357 12.1603L11.3088 15.631L8.2778 13.7281L7.87902 13.4777L7.48024 13.7281L4.44921 15.631L5.32234 12.1603L5.43722 11.7037L5.07588 11.4018L2.32947 9.10711L5.90013 8.865L6.3699 8.83315L6.54537 8.39621L7.87902 5.07512Z",
    stroke: "#C93030",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0046 5.07512L15.8274 9.61423L16.0029 10.0512L16.4727 10.083L21.3529 10.4139L17.5992 13.5502L17.2379 13.8521L17.3527 14.3087L18.5461 19.0523L14.4034 16.4515L14.0046 16.2011L13.6059 16.4515L9.46318 19.0523L10.6565 14.3087L10.7714 13.8521L10.4101 13.5502L6.65641 10.4139L11.5366 10.083L12.0064 10.0512L12.1819 9.61423L14.0046 5.07512Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.002 7.22747L15.2685 10.3812L15.444 10.8182L15.9137 10.85L19.3045 11.0799L16.6965 13.259L16.3351 13.5609L16.45 14.0175L17.2792 17.3134L14.4008 15.5063L14.002 15.256L13.6033 15.5063L10.7249 17.3134L11.5541 14.0175L11.669 13.5609L11.3076 13.259L8.69956 11.0799L12.0903 10.85L12.5601 10.8182L12.7356 10.3812L14.002 7.22747Z",
    fill: "white",
    stroke: "#C93030",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceIcon);
export default __webpack_public_path__ + "static/media/experience-icon.c2b274a9ce3563a11cb6b336126e7dca.svg";
export { ForwardRef as ReactComponent };